<script lang="ts">
    import { onMount } from "svelte";
    import { Table } from 'attractions';
    import Employee from "../../../Models/Employee";
    import Total from "./Total.svelte";
    import Currency from "../../../Utils/Currency";

    export let employeeID: string;

    const headers = [
        { text: 'Data', value: 'date' },
        { text: 'Produkt', value: 'product' },
        { text: 'Cena', value: 'price' }
    ]

    let items: any[];

    onMount(async () => {
        const purchases = await Employee.getPurchases(employeeID);
        items = purchases.map(purchase => {
            const { date, price, product } = purchase;
            return {
                date: new Date(date).toLocaleDateString('pl', { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "numeric" }),
                price: Currency.format(price),
                product
            }
        });
        items = items.reverse();
    })
</script>

{#if items && items.length}
    <section class="purchasesTable">
        <Table {headers} {items} /> 
        <Total purchases={items} />
    </section>
{:else}
    <h3>Nie znaleźliśmy żadnych zakupów dla tego użytkownika</h3>
{/if}